import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import firebase from '../../firebase/firebaseConfig';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  table: {
    minWidth: 650,
    '@media (max-width: 890px)': {
      minWidth: 0,
    },
  },
  tableHead: {
    backgroundColor: 'black',
  },
}));

function createData(date, packageName, amount, status) {
  return { date, packageName, amount, status };
}
const dateOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

const getSpanishPackage = (packageName) => {
  if (packageName.includes(10)) return 'Paquete de 10 Clases';
  if (packageName.includes(1)) return 'Paquete de 1 Clase';
  if (packageName.includes(20)) return 'Paquete de 20 Clases';
};
const getSpanishStatus = (packageStatus) => {
  switch (packageStatus) {
    case 'paid':
      return 'pagado';
    case 'unpaid':
      return 'sin pagar';
    case 'no_payment_required':
      return 'no require pagar';
    default:
      throw 'Payment Status is outside of the allowed values - AN';
      break;
  }
};
const AccountPayments = ({ user }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [payments, setPayments] = useState([]);
  console.log(user);
  useEffect(() => {
    (async () => {
      const querySnapshot = await firebase
        .firestore()
        .collection('class_accounts')
        .doc(user.uid)
        .collection('payments')
        .get();

      setPayments(querySnapshot.docs.map((doc) => doc.data()));
      setLoading(false);
    })();
  }, [user]);

  const rows = payments.map((payment) =>
    createData(
      user.lang === 'English'
        ? payment.date.toDate().toDateString()
        : payments[0].date.toDate().toLocaleDateString('es-ES', dateOptions),
      user.lang === 'English'
        ? payment.packageName
        : getSpanishPackage(payment.packageName),
      payment.amountTotal,
      user.lang === 'English'
        ? payment.paymentStatus
        : getSpanishStatus(payment.paymentStatus)
    )
  );

  return (
    <div className={classes.content}>
      <h1> {user.lang === 'English' ? 'Payments' : 'Pagos'}</h1>
      {loading && <CircularProgress />}
      {!loading && payments.length === 0 && (
        <h3>
          {user.lang === 'English'
            ? 'There is no payment history to show'
            : 'No hay una historia de pago para mostrar'}{' '}
        </h3>
      )}
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label='simple table'>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold', color: 'white' }}>
                {user.lang === 'English' ? 'Date' : 'Fecha'}
              </TableCell>
              <TableCell
                style={{ fontWeight: 'bold', color: 'white' }}
                align='right'
              >
                {user.lang === 'English' ? 'Package' : 'Paquete'}
              </TableCell>
              <TableCell
                style={{ fontWeight: 'bold', color: 'white' }}
                align='right'
              >
                {user.lang === 'English' ? 'Amount' : 'Monto'}
              </TableCell>
              <TableCell
                style={{ fontWeight: 'bold', color: 'white' }}
                align='right'
              >
                {user.lang === 'English' ? 'Status' : 'Estado'}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i}>
                <TableCell component='th' scope='row'>
                  {row.date}
                </TableCell>
                <TableCell align='right'>{row.packageName}</TableCell>
                <TableCell align='right'>${row.amount}</TableCell>
                <TableCell align='right'>{row.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* {payments.map((payment) => {
        return (
          <div key={payment.checkoutSessionId}>
            <h4>{payment.date.toDate().toDateString()}</h4>
            <h3>{payment.packageName}</h3>
            <p>Amount Paid: ${payment.amountTotal}</p>
            <p>Status: {payment.paymentStatus}</p>
            <p>Discount: {payment.discount}</p>
            <Divider variant='fullWidth' />
          </div>
        );
      })} */}
    </div>
  );
};

export default AccountPayments;
